import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import { FormInput } from '../../../../../components/form';
import useIsFirstRender from '../../../../../state/hooks/useIsFirstRender';




function DeviceListFilters({ initialData, searching, onSearch }: Props) {

    const initial = useIsFirstRender();

    useEffect(() => {
        if (initial) {

        }
    }, []);


    const handleSubmit = (values: any, { reset }: any) => {
        const payload = { ...values };

        onSearch(payload);
    }


    return (
        <Formik
            initialValues={{
                // name: initialData['name'] || '',
                connectionStatus: initialData['connectionStatus'] || '',
                email: initialData['email'] || '',
                primaryContact: initialData['primaryContact'] || '',
            }}
            onSubmit={handleSubmit}
            enableReinitialize
        >
            {({ errors, touched, setErrors, submitCount, values, isValid, setFieldValue, resetForm }) => (
                <Form className="flex-grow flex items-center flex-wrap mr-8 gap-y-4 gap-x-4" autoComplete="off">

                    <FormInput type="text" id="input-search-name" name="name" className="lg:w-full lg:max-w-xs" placeholder="Search name" autoComplete='off' />
                    <FormInput type="text" id="input-search-email" name="email" className="hidden md:block" placeholder="Search email" autoComplete='off' />
                    <FormInput type="text" id="input-search-primary-contact" name="primaryContact" className="hidden md:block" placeholder="Search primary contact" autoComplete='off' />

                    
                    <button type='submit' className='text-blue-500 hover:text-blue-600 disabled:text-blue-400 px-2' disabled={searching}>Search</button>
                </Form>
            )}
        </Formik>
    );
}


interface Props {
    initialData: any;
    onSearch: (values: any) => void;
    searching: boolean;
}


export default DeviceListFilters;